export default __webpack_public_path__ + "static/media/login.dbb2f11d.png";